import { useState } from "react";
import { Trash2 } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { photoUrl } from "@/lib/api";

export default function PhotoGrid({ photos, canDelete, onDelete }) {
  const [open, setOpen] = useState(null);
  if (!photos.length)
    return <p data-testid="gallery-empty" className="text-lg text-stone-600">No photos yet. Be the first to share one!</p>;
  return (
    <>
      <div className="columns-2 md:columns-3 lg:columns-4 gap-4 [&>*]:mb-4" data-testid="photo-gallery">
        {photos.map((p) => (
          <figure key={p.id} data-testid={`photo-card-${p.id}`} className="break-inside-avoid rounded-2xl overflow-hidden bg-white border border-amber-900/15 shadow-sm">
            <button type="button" data-testid={`photo-open-${p.id}`} onClick={() => setOpen(p)} className="block w-full">
              <img src={photoUrl(p.id)} alt={p.caption || "Reunion photo"} loading="lazy" className="w-full h-auto hover:opacity-90" />
            </button>
            <figcaption className="p-3 flex items-start justify-between gap-2">
              <div className="min-w-0"><p className="font-semibold truncate">{p.caption || "\u00a0"}</p><p className="text-sm text-stone-600 truncate">{p.uploader_name}</p></div>
              {canDelete(p) && (
                <button data-testid={`photo-delete-${p.id}`} aria-label="Delete photo" onClick={() => onDelete(p)} className="shrink-0 p-2 rounded-full text-red-700 hover:bg-red-50"><Trash2 className="w-5 h-5" /></button>
              )}
            </figcaption>
          </figure>
        ))}
      </div>
      <Dialog open={!!open} onOpenChange={(v) => !v && setOpen(null)}>
        <DialogContent className="max-w-4xl p-3 bg-stone-950 border-stone-800" data-testid="photo-lightbox">
          <DialogTitle className="text-amber-50 px-2">{open?.caption || open?.uploader_name}</DialogTitle>
          {open && <img src={photoUrl(open.id)} alt={open.caption || "Reunion photo"} className="w-full max-h-[78vh] object-contain rounded-xl" />}
        </DialogContent>
      </Dialog>
    </>
  );
}
